// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "specialist-260824-8/static/css/" + chunkId + "." + {"481":"144724f8","660":"25a55b8a","978":"79c0b1cb"}[chunkId] + ".chunk.css";
};